/**
 * Clave de licencia Froala (misma que avisos / noticesV2).
 * Si en el futuro se centraliza en environment, sustituir aquí.
 */
export const MUNILY_FROALA_LICENSE_KEY =
  'cJC7bA5B2G2F2F2H2ykrff1frF4nablA6F6D5E4A1D3C11A3A5E4==';
